// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/put-feedback-request-schema',
  type: 'object',
  required: ['companyId', 'youthVisitorsCount', 'id'],
  properties: {
    companyId: {
      type: 'integer',
    },
    eventRating: {
      enum: [
        1,
        2,
        3,
      ],
    },
    reparticipationRating: {
      enum: [
        1,
        2,
        3,
      ],
    },
    youthVisitorsCount: {
      type: 'integer',
    },
    adultVisitorsCount: {
      type: 'integer',
      nullable: true,
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    id: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
